var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductCategorySelect',{attrs:{"only-selectable":false,"selected-items":_vm.value},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }